<template>
    <div>
        <el-row class="searchSection">
            <el-form ref="form" :inline="true" :model="searcheModel" class="external-form">
                <el-form-item label="时间">
                    <el-date-picker
                        size="small"
                        v-model="searcheModel.created_at"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="所属部门">
                    <UserCascader
                    v-model="searcheModel.branch_id"
                    ref="branch"
                    :isBusiness="true"
                    @change="changeBranch"
                    ></UserCascader>
                </el-form-item>
                <el-form-item label="业务员">
                    <UserSelect ref="user" @change="changeUser"></UserSelect>
                </el-form-item>
                <el-form-item label="财务审核">
                    <el-select size="small" v-model="searcheModel.finance_audit" placeholder="请选择">
                        <el-option label="不限" value=""></el-option>
                        <el-option label="通过" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="过滤销售额为0的订单">
                    <el-select size="small" v-model="searcheModel.not_have_amount" placeholder="请选择">
                        <el-option label="不限" value=""></el-option>
                        <el-option label="是" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="产品类型">
                    <Product ref="product" :product_id="searcheModel.product_id"
                    @change="productChange"></Product>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="submitSearch">搜索</el-button>
                    <el-button @click="resetForm()" size="small">重置</el-button>
                    <ExportFile 
                    v-if="Acs('/sale-analysis/' + activeName)"
                    :url="'/api/export/' + activeName" 
                    :params="searcheModel" 
                    filename="日跟进分析" 
                    buttonName="导出Excel">
                    </ExportFile>
                </el-form-item>
            </el-form>
        </el-row>
        <el-row class="searchSection">
            <el-col :span="22">
                <el-tabs type="card" v-model="searcheModel.count_type" @tab-click="submitSearch">
                    <el-tab-pane label="按部门" name="1"></el-tab-pane>
                    <el-tab-pane label="按成员" name="2"></el-tab-pane>
                </el-tabs>
            </el-col>
            <el-col :span="2">
                <CountConfig v-if="Acs('/count-config/view')" :path="$route.path" :tab="activeName"></CountConfig>
            </el-col>
        </el-row>
        <p style="color:#85CE61;">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：已经对部门内成员重复的线索、客户数据进行去重
        </p>
        <div class="main-bd mg20 pro-visible" v-loading="loading">
            <h3>跟进情况分析(按跟进时间)</h3>
            <el-table 
            v-if="!loading"
            :data="list" 
            border 
            max-height="450"
            row-key="id" 
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            :header-cell-style="{background: '#f3faff'}"
            :summary-method="getSummaries"
            show-summary
            key="1"
            >
                <template v-if="searcheModel.count_type == 1">
                    <el-table-column prop="name" label="部门丨业务员" width="200"></el-table-column>
                </template>
                <template v-else>
                    <el-table-column prop="name" label="业务员"></el-table-column>
                    <el-table-column prop="branch_name" label="所属部门"></el-table-column>
                </template>
                <el-table-column prop="clue_num" label="已跟进线索数" sortable></el-table-column>
                <el-table-column prop="traces_clue_num" label="跟进线索次数" sortable></el-table-column>
                <el-table-column prop="customer_num" label="跟进客户数" sortable></el-table-column>
                <el-table-column prop="traces_customer_num" label="跟进客户次数" sortable></el-table-column>
            </el-table>
        </div>
        <div class="main-bd mg20 pro-visible" v-loading="order_loading">
            <h3>成交结果分析(按录单时间)</h3>
            <el-table 
            v-if="!order_loading"
            :data="order_list" 
            border 
            max-height="450"
            row-key="id" 
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            :header-cell-style="{background: '#f3faff'}"
            :summary-method="getSummaries"
            show-summary
            key="2"
            >
                <template v-if="searcheModel.count_type == 1">
                    <el-table-column prop="name" label="部门丨业务员" width="200"></el-table-column>
                </template>
                <template v-else>
                    <el-table-column prop="name" label="业务员"></el-table-column>
                    <el-table-column prop="branch_name" label="所属部门"></el-table-column>
                </template>
                <el-table-column prop="try_out_customer_num" label="试用客户数" sortable>
                    <template slot-scope="scope">
                        <el-button type="text" @click="customerDialog(scope.row, 1)">
                            {{ scope.row.try_out_customer_num }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="try_out_order_num" label="试用订单数" sortable>
                    <template slot-scope="scope">
                        <el-button type="text" @click="dialogShow(scope.row, 1)">
                            {{ scope.row.try_out_order_num }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="deep_trial_customer_num" sortable>
                    <template slot="header">
                        <!-- 自定义表头 -->
                        <span>有效试用客户数</span>
                        <el-tooltip class="item" effect="dark" content="开通试用订单，并有下载资料的客户，要求科目数>=2，下载量>=50" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        <el-button type="text" @click="customerDialog(scope.row, 1, 1)">
                            {{ scope.row.deep_trial_customer_num }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="try_deal_customer_num" label="试用后成交客户" sortable></el-table-column>
                <el-table-column prop="deal_customer_num" label="成交客户数" sortable>
                    <template slot-scope="scope">
                        <el-button type="text" @click="customerDialog(scope.row, 4)">
                            {{ scope.row.deal_customer_num }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="deal_order_num" label="正式订单数" sortable>
                    <template slot-scope="scope">
                        <el-button type="text" @click="dialogShow(scope.row, 4)">
                            {{ scope.row.deal_order_num }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="pfm_amount" label="新增业绩" sortable></el-table-column>
                <el-table-column prop="pfm_order_num" label="新增订单数" sortable>
                    <template slot-scope="scope">
                        <el-button type="text" @click="dialogShow(scope.row, 2)">
                            {{ scope.row.pfm_order_num }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="renew_amount" label="续费业绩" sortable></el-table-column>
                <el-table-column prop="renew_order_num" label="续费单数" sortable>
                    <template slot-scope="scope">
                        <el-button type="text" @click="dialogShow(scope.row, 3)">
                            {{ scope.row.renew_order_num }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <DayOrderDialog v-if="dialogTableVisible" :params="params" @close="closeDialog"></DayOrderDialog>
        <DayCustomerDialog v-if="dialogCustomerVisible" :params="params" @close="closeDialog"></DayCustomerDialog>
    </div>
  </template>
  <style scoped>
  </style>
  <script>
  import SaleanalysisCount from "~/services/saleanalysisCount";
  import UserCascader from "~/widgets/UserCascader.vue";
  import UserSelect from "~/widgets/UserSelect.vue";
  import Config from "~/config/params";
  import ExportFile from "~/widgets/ExportFile.vue";
  import CountConfig from "~/widgets/CountConfig.vue";
  import DayOrderDialog from "~/views/count/dialog/DayOrderDialog.vue";
  import DayCustomerDialog from "~/views/count/dialog/DayCustomerDialog.vue";
  import Product from "~/widgets/Product.vue";
  export default {
    name: "dayTraces",
  
    components: {
        UserCascader,
        UserSelect,
        Config,
        ExportFile,
        CountConfig,
        DayOrderDialog,
        DayCustomerDialog,
        Product
    },
  
    props: {
        activeName: {
            type: String,
            default: ''
        }
    },
  
    data() {
        return {
            loading: false,
            list: [],
            searcheModel: {},
            order_loading: false,
            order_list: [],
            params: {},
            dialogTableVisible: false,
            dialogCustomerVisible: false,
        };
    },
  
    mounted() {
        this.resetForm();
    },
  
    created() {
        
    },
  
    methods: {
        //重置按钮
        resetForm() {
            this.searcheModel = {
                branch_id: "",
                user_id: "",
                count_type: '1',
                created_at: Config.getDataTimes('to_day'),
                path: this.$route.path,
                tab: this.activeName,
                finance_audit: '',
                not_have_amount: '',
                product_id: '',
            };
            this.$refs['user'].reset();
            this.$refs['branch'].reset();
            this.list = [];
            this.submitSearch();
        },
    
        // 筛选查询
        submitSearch() {
            let params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            this.getList(params);
            this.getOrderList(params);
        },
    
        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            SaleanalysisCount.getList(params, this.activeName).then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },

        //获取列表
        getOrderList(params) {
            // loading 动画
            this.order_loading = true;
            SaleanalysisCount.getList(params, 'day-order').then((res) => {
                if (res.code == 0) {
                    this.order_list = res.data;
                }
                this.order_loading = false;
            }).catch((err) => {
                console.error(err);
                this.order_loading = false;
            });
        },
    
        //切换业务员子组件
        changeUser(object) {
            this.searcheModel.user_id = object.label;
        },

        //切换部门子组件
        changeBranch(value) {
            if (value.length > 0) {
                // 取得最后一级部门作为所属部门
                this.searcheModel.branch_id = value[value.length - 1];
            } else {
                this.searcheModel.branch_id = "";
            }
        },

        productChange(value) {
            this.searcheModel.product_id = value;
        },

        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                // 第一列不计算合计，显示自定义的文字内容
                if (index === 0) {
                    sums.push('合计：' + data.length + '条');
                    return;
                }
                // 初始化合计值为0
                let sum = 0;
                // 遍历数据，累加顶级行的值
                data.forEach(item => {
                    // 累加当前项的值，注意转换为数字
                    sum += Number(item[column.property]);
                });
                // 如果所有值都是数字，则显示合计结果，否则显示'-'
                if (!isNaN(sum)) {
                    sums.push(Math.round(sum * 100) / 100); // 保留两位小数
                } else {
                    sums.push('--');
                }
            });
            return sums;
        },

        dialogShow(item, order_type){
            if(order_type == 1 && item.try_out_order_num == 0 || 
            order_type == 2 && item.pfm_order_num == 0 || 
            order_type == 3 && item.renew_order_num == 0 || 
            order_type == 4 && item.deal_customer_num == 0){
                return false;
            }
            this.params = _.clone(this.searcheModel);
            if(item.hasOwnProperty('user_id')){
                this.params['user_id'] = item.user_id;
            }else if(item.hasOwnProperty('branch_id')){
                this.params['branch_id'] = item.branch_id;
            }
            this.params['order_type'] = order_type;
            this.dialogTableVisible = true;
        },

        customerDialog(item, order_type, is_deep_trial = 0){
            if(order_type == 1 && item.try_out_customer_num == 0 || 
            order_type == 4 && item.deal_customer_num == 0 || 
            order_type == 5 && item.deep_trial_customer_num == 0){
                return false;
            }
            this.params = _.clone(this.searcheModel);
            if(item.hasOwnProperty('user_id')){
                this.params['user_id'] = item.user_id;
            }else if(item.hasOwnProperty('branch_id')){
                this.params['branch_id'] = item.branch_id;
            }
            this.params['order_type'] = order_type;
            if (is_deep_trial){
                this.params['is_deep_trial'] = is_deep_trial;
            }
            this.dialogCustomerVisible = true;
        },

        closeDialog(){
            this.dialogTableVisible = false;
            this.dialogCustomerVisible = false;
            this.params = {};
        },
    },
  };
  </script>


// WEBPACK FOOTER //
// src/views/count/table/dayTraces.vue